var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      title: "材料补充记录",
      visible: _vm.visible,
      width: "660px",
      "before-close": _vm.handleClose,
      "close-on-click-modal": false,
      "append-to-body": "",
      "custom-class": "supplement-record-dialog"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "record-list"
  }, [_c("div", [_c("div", {
    staticClass: "record-group"
  }, [_c("div", {
    staticClass: "flex justify-between items-center mb12px"
  }, [_c("span", {
    staticClass: "text-14px font-600 color-#666"
  }, [_vm._v("首次提交")]), _c("span", {
    staticClass: "text-14px color-#666"
  }, [_vm._v(_vm._s(_vm._f("dateFormat")(_vm.complaint.create, "YYYY-MM-DD HH:mm")))])]), _c("div", {
    staticClass: "flex mb12px"
  }, [_c("span", {
    staticClass: "text-14px color-#666 w-70px flex-shrink-0"
  }, [_vm._v("投诉理由")]), _c("span", {
    staticClass: "text-14px color-#666 flex-1"
  }, [_vm._v(_vm._s(_vm.complaint.reason))])]), _c("div", {
    staticClass: "flex mb12px"
  }, [_c("span", {
    staticClass: "text-14px color-#666 w-70px flex-shrink-0"
  }, [_vm._v("投诉凭证")]), _c("div", {
    staticClass: "flex flex-wrap flex-1"
  }, _vm._l(_vm.complaint.imgs, function (img, idx) {
    return _c("wlc-image", {
      key: idx,
      staticClass: "mr-8px mb-2 rounded-4px",
      attrs: {
        src: img,
        width: "56",
        height: "56",
        list: _vm.complaint.imgs,
        current: idx
      }
    });
  }), 1)])])]), _vm._l(_vm.records, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      staticClass: "w-full h-1px bg-#f5f5f5 my-15px"
    }), _c("div", {
      staticClass: "record-group"
    }, [_c("div", {
      staticClass: "flex justify-between items-center mb12px"
    }, [_c("span", {
      staticClass: "text-14px font-600 color-#666"
    }, [_vm._v(_vm._s("\u7B2C ".concat(index + 1, "\u6B21\u8865\u5145")) + " ")]), _c("span", {
      staticClass: "text-14px color-#666"
    }, [_vm._v(_vm._s(_vm._f("dateFormat")(item.createdAt, "YYYY-MM-DD HH:mm")))])]), _c("div", {
      staticClass: "flex mb12px"
    }, [_c("span", {
      staticClass: "text-14px color-#666 w-70px flex-shrink-0"
    }, [_vm._v("投诉理由")]), _c("span", {
      staticClass: "text-14px color-#666 flex-1"
    }, [_vm._v(_vm._s(item.content))])]), _c("div", {
      staticClass: "flex mb12px"
    }, [_c("span", {
      staticClass: "text-14px color-#666 w-70px flex-shrink-0"
    }, [_vm._v("投诉凭证")]), _c("div", {
      staticClass: "flex flex-wrap flex-1"
    }, _vm._l(item.attachments, function (img, idx) {
      return _c("wlc-image", {
        key: idx,
        staticClass: "mr-8px mb-2 rounded-4px",
        attrs: {
          src: img,
          width: "56",
          height: "56",
          list: item.attachments,
          current: idx
        }
      });
    }), 1)])])]);
  })], 2), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("关闭窗口")]), _vm.info.complaint.statusV2 !== "RESOLVED" && _vm.info.complaint.statusV2 !== "SUSPENDED" ? _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.handleResolve
    }
  }, [_vm._v("立即处理")]) : _vm._e()], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };